import { IShipment, Shipment, ShipmentStatus } from '@packlink/packlink-sdk';
import { useTenantConfig } from '@packlink/tenant-config-provider';
import { LabelStatus } from '@types';
import { first } from 'lodash';

export function getShipmentActiveLabel(shipment: Shipment<IShipment>): string | undefined {
    return first(shipment.labels);
}

export function getShipmentOrderId(shipment: Shipment<IShipment>): string {
    return (shipment.additionalData.order_id as string | undefined) || 'notFoundOrderId';
}

export function getShipmentWeight({ parcels = [] }: Shipment<IShipment>): number {
    return parcels.reduce((previousWeight, parcel) => previousWeight + (parcel.weight || 0), 0);
}

export const inferLabelStatus = (state: IShipment['state'] | null): LabelStatus => {
    if (!state) {
        return LabelStatus.NOT_REQUESTED;
    }

    switch (state) {
        case ShipmentStatus.PURCHASE_SUCCESS:
        case ShipmentStatus.CARRIER_PENDING:
        case ShipmentStatus.CARRIER_OK:
        case ShipmentStatus.CARRIER_KO:
        case ShipmentStatus.LABELS_KO:
        case ShipmentStatus.RETRY:
            return LabelStatus.PROCESSING;
        case ShipmentStatus.READY_TO_PRINT:
        case ShipmentStatus.READY_FOR_COLLECTION:
        case ShipmentStatus.IN_TRANSIT:
        case ShipmentStatus.OUT_FOR_DELIVERY:
        case ShipmentStatus.DELIVERED:
        case ShipmentStatus.RETURNED_TO_SENDER:
        case ShipmentStatus.INCIDENT:
            return LabelStatus.READY;
        case ShipmentStatus.CANCELED:
        case ShipmentStatus.CANCEL_REQUESTED:
            return LabelStatus.CANCELLED;
        default:
            return LabelStatus.NOT_REQUESTED;
    }
};

export const usePackingSlipUrl = (ref: string): string => {
    const {
        externalPages: { packingSlip: packingSlipUrl },
    } = useTenantConfig<ITenantConfig>();
    return packingSlipUrl.replace('{{ORDERID}}', ref);
};

export const getPackingSlipRef = (params: URLSearchParams): string => {
    const tParam = params.get('t');
    const itemId = params.get('itemId');
    const orderId = params.get('orderId');
    const transId = params.get('transId');

    return tParam?.trim() || orderId?.trim() || (itemId && transId && `${itemId.trim()}-${transId.trim()}`) || '';
};
